<template>
  <a-modal
    v-model="visible"
    title="Edit Penalty Type"
  >
    <template slot="footer">
      <a-button @click="handleCancel">Cancel</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit">
        Edit Penalty Type
      </a-button>
    </template>

    <a-form :form="form">
      <a-form-item label="Name">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: 'Please enter name' }] },
          ]"
        />
      </a-form-item>

      <a-form-item label="Description">
        <a-input v-decorator="['description']" />
      </a-form-item>

        <a-form-item label="Severity">
            <a-select v-decorator="['severity', { rules: [{ required: true, message: 'Please select severity' }] }]">
                <a-select-option value="minor">Minor</a-select-option>
                <a-select-option value="medium">Medium</a-select-option>
                <a-select-option value="major">Major</a-select-option>
            </a-select>
        </a-form-item>

      <a-form-item label="Active">
        <a-checkbox v-decorator="['active', { valuePropName: 'checked' }]">
          Active
        </a-checkbox>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'EditPenaltyType',
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      editId: null,
    }
  },
  mounted() {
    this.$eventBus.$on('openSeverityEditModal', this.loadSeverity)
  },
  beforeDestroy() {
    this.$eventBus.$off('openSeverityEditModal', this.loadSeverity)
  },
  methods: {
    loadSeverity(id) {
      this.editId = id
      this.visible = true
      this.loading = true
      this.$http
        .get(`/api/discipline-penalty/${id}`)
        .then(({ data }) => {
          const severity = data.data
          this.form.setFieldsValue({
            name: severity.name,
            description: severity.description,
            severity: severity.severity,
            active: severity.active === 1,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .put(`/api/discipline-penalty/${this.editId}`, {
              name: values.name,
              description: values.description,
              severity: values.severity,
              active: values.active ? 1 : 0,
            })
            .then(() => {
              this.visible = false
              this.$emit('edited')
              this.$notification.success({
                message: 'Severity Updated',
                description: `${values.name} updated successfully.`,
              })
            })
            .catch((error) => {
              this.$neoNotify.error(error)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
